import { useEffect, useState } from "react";
import useLanguage from "../common_hooks/useLanguage";
import { useDispatch, useSelector } from "react-redux";
import { pin_project, unpin_project } from "../../App/actions/projectActions";

function PINNED_BUTTON(props = {}) {
  // Destructure on_close_menu from the props object
  const { on_close_menu } = props;

  const dispatch = useDispatch();
  const { dict, language } = useLanguage();
  const [is_project_inside_pinned, set_is_project_inside_pinned] =
    useState(false);

  const { project } = useSelector((state) => {
    return {
      project: state.project,
    };
  });

  /**
   * This effect runs when the component mounts and whenever the project data changes.
   * It checks if the current project is in the user's pinned list.
   */
  useEffect(() => {
    const { geo_project_pinned_list, geo_project } = project;
    const is_inside_pinned = geo_project_pinned_list?.some(
      (pinned_project) => pinned_project?._id === geo_project?._id
    );
    set_is_project_inside_pinned(is_inside_pinned);
    // Dependency array updated to re-run the effect if project data changes.
  }, [project]);

  /**
   * Handles the pin/unpin action when the button is clicked.
   * It dispatches the appropriate Redux action and then calls the
   * on_close_menu function passed in from the parent component.
   */
  const handle_pin = async (e) => {
    const geo_project_id = project?.geo_project?._id;
    const body = { geo_project_id };

    if (is_project_inside_pinned) {
      dispatch(unpin_project(body, project?.geo_project));
    } else {
      dispatch(pin_project(body, project?.geo_project));
    }

    on_close_menu();
  };

  const button_text = is_project_inside_pinned ? "Unpin" : "Pin";

  return (
    <>
      <button
        className="button_big margin_bottom button_white"
        onClick={handle_pin}
        data-mapid="pinLayer"
      >
        {dict[button_text][language]}
      </button>
    </>
  );
}

export default PINNED_BUTTON;
